var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "cog-section",
      class: [
        "cog-col",
        _vm.colNumClass,
        {
          "is-error": _vm.showValidation,
          "cog-section--heading": _vm.$source.label && !_vm.hideLabel,
          ["cog-field--" + _vm.fieldIndex]: _vm.fieldIndex,
          "cog-force-shown": _vm.forceShown,
          "hidden-label": _vm.hideLabel
        }
      ],
      attrs: {
        "aria-labelledby": _vm.$source.id ? "cog-" + _vm.$source.id : false,
        tabindex: _vm.showValidation ? 0 : -1,
        "aria-describedby": _vm.showValidation
          ? `cog-${_vm.$source.id}-error`
          : undefined,
        "aria-invalid": _vm.showValidation ? true : undefined
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "cog-section__inner",
          class: {
            "cog-section__inner--background ": _vm.background === "main",
            "cog-section__inner--background is-alternate":
              _vm.background === "alternate",
            "cog-section__inner--no-background ": _vm.background === "none"
          }
        },
        [
          _vm._t("header", function() {
            return [
              _vm.showLabel
                ? _c(
                    "h" + Math.min(_vm.depth + 1, 4),
                    {
                      tag: "h2",
                      staticClass: "cog-section__heading cog-heading",
                      attrs: { id: "cog-" + _vm.$source.id }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$source.label) + "\n\t\t\t\t"
                      ),
                      _vm.showValidation
                        ? _c("span", { staticClass: "cog-offscreen" }, [
                            _vm._v(", " + _vm._s(_vm.firstError.message))
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$source.helptext && !_vm.$source.readonly
                ? _c("div", {
                    staticClass: "cog-helptext cog-html",
                    domProps: { innerHTML: _vm._s(_vm.$source.helptext) }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _vm._t("default", null, {
            entity: _vm.$source.value,
            adapter: _vm.$source,
            cols: _vm.cols
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "cog-error-message" } }, [
        _vm.showValidation
          ? _c(
              "div",
              {
                staticClass:
                  "cog-error-message cog-error-message--container-footer",
                attrs: {
                  id: `cog-${_vm.$source.id}-error`,
                  "aria-live": _vm.showLabel ? null : "polite",
                  role: "alert"
                }
              },
              [_vm._v(_vm._s(_vm.firstError.message))]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }